import React from 'react';

const ImportIcon = () => (
    <svg viewBox="0 0 100 100">
        <polygon points="41.231,37.733 39.185,39.93 48.403,48.5 14.088,48.5 14.088,51.5 48.409,51.5 39.185,60.072 41.231,62.269   54.425,50.002 "></polygon>
        <polygon points="87.412,78.922 29.567,78.922 29.567,60.143 32.567,60.143 32.567,75.922 84.412,75.922 84.412,24.078   32.567,24.078 32.567,39.856 29.567,39.856 29.567,21.078 87.412,21.078 "></polygon>
    </svg>
);

export default ImportIcon;